import { API_ENDPOINTS } from "@/api/services/attendanceManagement/apiEndPoint";
import { baseApi } from "@/utils/baseApi";

export const onsiteAttendanceApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchEmployeeReport: builder.query({
      query: ({ empId, fromDate, toDate }) => ({
        url: API_ENDPOINTS.ONSITEATTENDANCE.EMPLOYEE_ATTENDANCE_REPORT(
          empId,
          fromDate,
          toDate
        ),
        method: "GET",
      }),
      providesTags: (result) =>
        result && Array.isArray(result)
          ? [{ type: "OnsiteAttendance", id: "LIST" }]
          : [{ type: "OnsiteAttendance", id: "LIST" }],
    }),
    // post
    onsiteBulkUpload: builder.mutation({
      query: ({ formData }) => {
        return {
          url: API_ENDPOINTS.ONSITEATTENDANCE.BULK_UPLOAD(),
          method: "POST",
          body: formData,
          responseHandler: async (response) => {
            if (!response.ok) {
              const errorData = await response.json();
              console.log(errorData);
              return errorData;
            }
            return response.blob();
          },
        };
      },
    }),
    processByDate: builder.mutation({
      query: ({ date }) => {
        return {
          url: API_ENDPOINTS.ONSITEATTENDANCE.PROCESS_BY_DATE(date),
          method: "POST",
          responseHandler: async (response) => {
            if (!response.ok) {
              const errorData = await response.json();
              console.log(errorData);
              return errorData;
            }
            return response.blob();
          },
        };
      },
    }),
    // sample
    getOnSiteAttendanceSample: builder.query({
      query: () => ({
        url: API_ENDPOINTS.ONSITEATTENDANCE.GET_ON_SITE_ATTENDANCE_SAMPLE(),
        responseHandler: async (response) => response.blob(), // Ensure Blob conversion
      }),
      providesTags: ["OnsiteAttendance"],
    }),
    fetchEmployeePunchReport: builder.query({
      query: ({ fromDate, toDate }) => ({
        url: API_ENDPOINTS.ONSITEATTENDANCE.EMPLOYEE_ATTENDANCE_PUNCH(
          fromDate,
          toDate
        ),
        method: "GET",
      }),
      providesTags: (result) =>
        result && Array.isArray(result)
          ? [{ type: "OnsiteAttendance", id: "LIST" }]
          : [{ type: "OnsiteAttendance", id: "LIST" }],
    }),
  }),
});

export const {
  useFetchEmployeeReportQuery,
  useOnsiteBulkUploadMutation,
  useProcessByDateMutation,
  useGetOnSiteAttendanceSampleQuery,
  useFetchEmployeePunchReportQuery,
} = onsiteAttendanceApi;
